import { render, staticRenderFns } from "./EstablishmentRoleCards.vue?vue&type=template&id=54f65f0e&"
import script from "./EstablishmentRoleCards.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports